import {
  createDataReducer,
  getDataReducerInitialState,
} from "@ea/shared_components/redux/reducers/common.data.reducer";

import { GlobalVariable } from "@ea/shared_types/types";
import { moduleActions } from "./globalVariables.actions";

const initialState = {
  ...getDataReducerInitialState<GlobalVariable>(),
};

export type GlobalVariablesReducer = typeof initialState;

const dataReducer = createDataReducer<GlobalVariable>({
  ...moduleActions.table,
  ...moduleActions.data,
});

export const reducer = dataReducer(initialState);
